import projectDataMessages from './messages';
import sharedMessages from '../shared-messages';
import {MessageObject, TranslatorFunction} from '../../gui-config';

const messages = {...projectDataMessages, ...sharedMessages};

// use the default message if a translation function is not passed
const defaultTranslator = (msgObj: MessageObject) => msgObj.defaultMessage;

/**
 * Generate a localized version of the default project
 * @param {function} translateFunction a function to use for translating the default names
 * @returns {object} the project data json for the default project
 */
const projectData = (translateFunction?: TranslatorFunction): object => {
    const translator = translateFunction || defaultTranslator;
    return ({
        targets: [
            {
                isStage: true,
                name: 'Stage',
                variables: {
                    '`jEk@4|i[#Fk?(8x)AV.-my variable': [
                        translator(messages.variable),
                        0
                    ]
                },
                lists: {},
                broadcasts: {},
                blocks: {},
                currentCostume: 0,
                costumes: [
                    {
                        assetId: 'cd21514d0531fdffb22204e0ec5ed84a',
                        name: translator(messages.backdrop, {index: 1}),
                        md5ext: 'cd21514d0531fdffb22204e0ec5ed84a.svg',
                        dataFormat: 'svg',
                        rotationCenterX: 240,
                        rotationCenterY: 180
                    }
                ],
                sounds: [
                    {
                        assetId: '83a9787d4cb6f3b7632b4ddfebf74367',
                        name: translator(messages.pop),
                        dataFormat: 'wav',
                        format: '',
                        rate: 11025,
                        sampleCount: 258,
                        md5ext: '83a9787d4cb6f3b7632b4ddfebf74367.wav'
                    }
                ],
                volume: 100
            },
            {
                isStage: false,
                name: translator(messages.sprite, {index: 1}),
                variables: {},
                lists: {},
                broadcasts: {},
                blocks: {},
                currentCostume: 7,
                costumes: [
                    {
                        assetId: 'b0fca233ad201a0fac289e123191a2e4',
                        name: 'king',
                        bitmapResolution: 2,
                        md5ext: 'b0fca233ad201a0fac289e123191a2e4.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: 'fb2750fd3fb0fb1074705cff5d4395d2',
                        name: 'idea lamp',
                        bitmapResolution: 2,
                        md5ext: 'fb2750fd3fb0fb1074705cff5d4395d2.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: 'd472ff5aa02e38c756f50ab38ecf226f',
                        name: 'strong',
                        bitmapResolution: 2,
                        md5ext: 'd472ff5aa02e38c756f50ab38ecf226f.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: 'ae5da50f2e4008eaef487e0fac6bcf2c',
                        name: 'strong fail',
                        bitmapResolution: 2,
                        md5ext: 'ae5da50f2e4008eaef487e0fac6bcf2c.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: '15064d4fc87fc24d999f725c1e282ba3',
                        name: 'book reader with hand up',
                        bitmapResolution: 2,
                        md5ext: '15064d4fc87fc24d999f725c1e282ba3.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: 'f6e635f6687bce6ebad389b33f6c3b1c',
                        name: 'book reader',
                        bitmapResolution: 2,
                        md5ext: 'f6e635f6687bce6ebad389b33f6c3b1c.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: '3d221ac554c3e0b503e64d46a180af03',
                        name: 'smartphone',
                        bitmapResolution: 2,
                        md5ext: '3d221ac554c3e0b503e64d46a180af03.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: '3b6ebda9bd09661fb8eb252d9fea082b',
                        name: 'like',
                        bitmapResolution: 2,
                        md5ext: '3b6ebda9bd09661fb8eb252d9fea082b.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: '3953ab7be30595a545f387e8c463a4dd',
                        name: 'qa',
                        bitmapResolution: 2,
                        md5ext: '3953ab7be30595a545f387e8c463a4dd.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: '70f5af8af7348675c4f0f3e5c9286e08',
                        name: 'flag',
                        bitmapResolution: 2,
                        md5ext: '70f5af8af7348675c4f0f3e5c9286e08.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    },
                    {
                        assetId: '550241e806d550454e945fa53a3fd059',
                        name: 'runner',
                        bitmapResolution: 2,
                        md5ext: '550241e806d550454e945fa53a3fd059.png',
                        dataFormat: 'png',
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    }
                ],
                sounds: [
                    {
                        assetId: '83c36d806dc92327b9e7049a565c6bff',
                        name: translator(messages.meow),
                        dataFormat: 'wav',
                        format: '',
                        rate: 22050,
                        sampleCount: 18688,
                        md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
                    }
                ],
                volume: 100,
                visible: true,
                x: 0,
                y: 0,
                size: 70,
                direction: 90,
                draggable: false,
                rotationStyle: 'all around'
            }
        ],
        meta: {
            semver: '3.0.0',
            vm: '0.1.0',
            agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/65.0.3325.181 Safari/537.36' // eslint-disable-line @stylistic/max-len
        }
    });
};


export default projectData;
